<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <!-- Breadcrumb -->
    <div class="mb-3 row">
      <div class="col-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link to="/tramite">Trámites</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'TramiteForm', params: { p_idtramite } }">
                Trámite N.° {{ p_idtramite }}
              </router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'TramiteForm',
                                  params: { p_idtramite },
                                  query: { tab: 'reportes' } }">
                Reportes
              </router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              Fechas por Período — Trámite N.° {{ p_idtramite }}
            </li>
          </ol>
        </nav>
      </div>
    </div>

    <div class="card border-0 mb-3" style="background-color: #e8f4fd;">
      <div class="card-body py-2 px-3">
        <span class="text-dark fw-bold">{{ datosTramite }}</span>
      </div>
    </div>

    <!-- Filtros -->
    <div class="row g-2 align-items-end mb-3">
      <div class="col-auto">
        <label class="form-label mb-0 small fw-bold">Tipo de observación</label>
        <select v-model="tipoSeleccionado" class="form-select form-select-sm" @change="cargarDatos">
          <option value="">Seleccione...</option>
          <option value="M">Auditoría Médica</option>
          <option value="D">Gestión Documental</option>
        </select>
      </div>
      <div class="col-auto">
        <button
          @click="cargarDatos"
          class="btn btn-primary btn-sm d-flex align-items-center gap-1"
          :disabled="!tipoSeleccionado || cargando"
        >
          <span class="material-icons" style="font-size: 16px">refresh</span>
          Actualizar
        </button>
      </div>
      <div class="col-auto ms-auto">
        <button
          @click="exportToExcel"
          class="btn btn-info btn-sm d-flex align-items-center gap-1"
          :disabled="porCarga.length === 0"
        >
          <span class="material-icons" style="font-size: 16px">download</span>
          Excel
        </button>
      </div>
    </div>

    <!-- Cargando -->
    <div v-if="cargando" class="alert alert-info py-2 px-3" role="alert">
      Cargando datos...
    </div>

    <!-- Sin selección -->
    <div v-else-if="!tipoSeleccionado" class="alert alert-secondary py-2 px-3" role="alert">
      Seleccione un tipo de observación para cargar los datos.
    </div>

    <div v-else>

      <!-- Tarjetas resumen global -->
      <div class="row g-3 mb-4">
        <div class="col-auto">
          <div class="card border-0 shadow-sm px-3 py-2 text-center" style="min-width: 160px;">
            <div class="small text-muted fw-bold">Períodos</div>
            <div class="fs-4 fw-bold text-primary">{{ porCarga.length }}</div>
          </div>
        </div>
        <div class="col-auto">
          <div class="card border-0 shadow-sm px-3 py-2 text-center" style="min-width: 180px;">
            <div class="small text-muted fw-bold">Fecha reg. mínima</div>
            <div class="fs-6 fw-bold text-dark">{{ resumenGlobal.minFechaReg }}</div>
          </div>
        </div>
        <div class="col-auto">
          <div class="card border-0 shadow-sm px-3 py-2 text-center" style="min-width: 180px;">
            <div class="small text-muted fw-bold">Fecha reg. máxima</div>
            <div class="fs-6 fw-bold text-dark">{{ resumenGlobal.maxFechaReg }}</div>
          </div>
        </div>
        <div class="col-auto">
          <div class="card border-0 shadow-sm px-3 py-2 text-center" style="min-width: 180px;">
            <div class="small text-muted fw-bold">Última act. respuesta</div>
            <div class="fs-6 fw-bold text-dark">{{ resumenGlobal.maxFechaActResp }}</div>
          </div>
        </div>
      </div>

      <!-- Sin datos -->
      <div v-if="porCarga.length === 0" class="alert alert-warning">
        No hay datos para mostrar.
      </div>

      <!-- Tabla por período -->
      <div class="table-responsive" v-else>
        <table class="table table-hover table-bordered table-sm">
          <thead class="table-dark">
            <tr>
              <th class="th-sort" @click="ordenarTabla('idCarga')">
                Período <span>{{ iconOrdenTabla('idCarga') }}</span>
              </th>
              <th class="th-sort" @click="ordenarTabla('total')">
                Total <span>{{ iconOrdenTabla('total') }}</span>
              </th>
              <!-- Fecha Registro -->
              <th class="th-sort bg-info bg-opacity-25"
                @click="ordenarTabla('minFechaReg')">
                F. Reg. Mín. <span>{{ iconOrdenTabla('minFechaReg') }}</span>
              </th>
              <th class="th-sort bg-info bg-opacity-25"
                @click="ordenarTabla('maxFechaReg')">
                F. Reg. Máx. <span>{{ iconOrdenTabla('maxFechaReg') }}</span>
              </th>
              <!-- Fecha Act. Observación -->
              <th class="th-sort bg-warning bg-opacity-25"
                @click="ordenarTabla('minFechaActObs')">
                F. Act. Mín. <span>{{ iconOrdenTabla('minFechaActObs') }}</span>
              </th>
              <th class="th-sort bg-warning bg-opacity-25"
                @click="ordenarTabla('maxFechaActObs')">
                F. Act. Máx. <span>{{ iconOrdenTabla('maxFechaActObs') }}</span>
              </th>
              <!-- Fecha Act. Respuesta -->
              <th class="th-sort bg-success bg-opacity-25"
                @click="ordenarTabla('minFechaActResp')">
                F. Resp. Mín. <span>{{ iconOrdenTabla('minFechaActResp') }}</span>
              </th>
              <th class="th-sort bg-success bg-opacity-25"
                @click="ordenarTabla('maxFechaActResp')">
                F. Resp. Máx. <span>{{ iconOrdenTabla('maxFechaActResp') }}</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in porCargaOrdenada" :key="item.idCarga">
              <td class="fw-bold">{{ labelCarga(item.idCarga) }}</td>
              <td>{{ item.total }}</td>
              <td>{{ formatFecha(item.minFechaReg) }}</td>
              <td>{{ formatFecha(item.maxFechaReg) }}</td>
              <td>{{ formatFecha(item.minFechaActObs) }}</td>
              <td>{{ formatFecha(item.maxFechaActObs) }}</td>
              <td>{{ formatFecha(item.minFechaActResp) }}</td>
              <td>{{ formatFecha(item.maxFechaActResp) }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="table-secondary fw-bold">
              <td>Global</td>
              <td>{{ datos.length }}</td>
              <td>{{ resumenGlobal.minFechaReg }}</td>
              <td>{{ resumenGlobal.maxFechaReg }}</td>
              <td>{{ resumenGlobal.minFechaActObs }}</td>
              <td>{{ resumenGlobal.maxFechaActObs }}</td>
              <td>{{ resumenGlobal.minFechaActResp }}</td>
              <td>{{ resumenGlobal.maxFechaActResp }}</td>
            </tr>
          </tfoot>
        </table>
      </div>

      <!-- Leyenda -->
      <div class="d-flex gap-4 mt-3 pt-3 border-top" v-if="porCarga.length > 0">
        <div class="d-flex align-items-center gap-1">
          <div style="width: 14px; height: 14px; background: #0dcaf0; opacity: 0.4; border-radius: 2px;"></div>
          <span class="small text-muted">Fecha de registro</span>
        </div>
        <div class="d-flex align-items-center gap-1">
          <div style="width: 14px; height: 14px; background: #ffc107; opacity: 0.4; border-radius: 2px;"></div>
          <span class="small text-muted">Fecha actualización</span>
        </div>
        <div class="d-flex align-items-center gap-1">
          <div style="width: 14px; height: 14px; background: #198754; opacity: 0.4; border-radius: 2px;"></div>
          <span class="small text-muted">Fecha respuesta</span>
        </div>
      </div>

    </div>

    <Footer />
  </div>
</template>

<script>
import Layout from "@/components/Layout.vue";
import Footer from "@/components/Footer.vue";
import api from "@/services/api";
import * as XLSX from "xlsx";

export default {
  name: "FechasPorPeriodo",
  components: { Layout, Footer },

  props: {
    p_idtramite: { type: Number, required: true },
  },

  data() {
    return {
      tipoSeleccionado: "",
      cargando:         false,
      datos:            [],
      cargas:           [],
      datosTramite:     "",
      campoOrdenTabla:  "idCarga",
      ascendenteTabla:  true,
    };
  },

  computed: {
    // ── Agrupar por idCarga calculando min/max de cada fecha ──
    porCarga() {
      const mapa = {};
      this.datos.forEach(item => {
        const clave = item.idCarga;
        if (!mapa[clave]) {
          mapa[clave] = {
            idCarga:        clave,
            total:          0,
            minFechaReg:    null,
            maxFechaReg:    null,
            minFechaActObs: null,
            maxFechaActObs: null,
            minFechaActResp: null,
            maxFechaActResp: null,
          };
        }
        const g = mapa[clave];
        g.total++;

        // fechaReg
        if (item.fechaReg) {
          const d = new Date(item.fechaReg);
          if (!g.minFechaReg || d < g.minFechaReg) g.minFechaReg = d;
          if (!g.maxFechaReg || d > g.maxFechaReg) g.maxFechaReg = d;
        }
        // fechaActObs
        if (item.fechaActObs) {
          const d = new Date(item.fechaActObs);
          if (!g.minFechaActObs || d < g.minFechaActObs) g.minFechaActObs = d;
          if (!g.maxFechaActObs || d > g.maxFechaActObs) g.maxFechaActObs = d;
        }
        // fechaActResp
        if (item.fechaActResp) {
          const d = new Date(item.fechaActResp);
          if (!g.minFechaActResp || d < g.minFechaActResp) g.minFechaActResp = d;
          if (!g.maxFechaActResp || d > g.maxFechaActResp) g.maxFechaActResp = d;
        }
      });
      return Object.values(mapa).sort((a, b) => a.idCarga - b.idCarga);
    },

    // ── Tabla ordenada ────────────────────────────────────
    porCargaOrdenada() {
      const campo = this.campoOrdenTabla;
      return [...this.porCarga].sort((a, b) => {
        const va = a[campo] instanceof Date ? a[campo]?.getTime() ?? 0
          : typeof a[campo] === 'number' ? a[campo]
          : 0;
        const vb = b[campo] instanceof Date ? b[campo]?.getTime() ?? 0
          : typeof b[campo] === 'number' ? b[campo]
          : 0;
        return this.ascendenteTabla ? va - vb : vb - va;
      });
    },

    // ── Resumen global ────────────────────────────────────
    resumenGlobal() {
      const todas = this.porCarga;
      const minMax = (arr, campo, dir) => {
        const vals = arr.map(g => g[campo]).filter(Boolean);
        if (!vals.length) return '—';
        const fn = dir === 'min' ? Math.min : Math.max;
        return this.formatFecha(new Date(fn(...vals.map(d => d.getTime()))));
      };
      return {
        minFechaReg:     minMax(todas, 'minFechaReg',    'min'),
        maxFechaReg:     minMax(todas, 'maxFechaReg',    'max'),
        minFechaActObs:  minMax(todas, 'minFechaActObs', 'min'),
        maxFechaActObs:  minMax(todas, 'maxFechaActObs', 'max'),
        minFechaActResp: minMax(todas, 'minFechaActResp','min'),
        maxFechaActResp: minMax(todas, 'maxFechaActResp','max'),
      };
    },
  },

  mounted() {
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    this.fetchCargas();
    this.datosTramite = sessionStorage.getItem("datosTramite");
  },

  methods: {
    async cargarDatos() {
      if (!this.tipoSeleccionado) return;
      this.cargando = true;
      try {
        const { data } = await api.get("/vwobservaciones/tramite-buscar-todos", {
          params: {
            idTramite: this.p_idtramite,
            tipo:      this.tipoSeleccionado,
          },
        });
        this.datos = Array.isArray(data) ? data : [];
        console.log("Muestra fechas:", this.datos[0]?.fechaReg, this.datos[0]?.fechaActObs, this.datos[0]?.fechaActResp);
        console.log("Keys producción:", Object.keys(this.datos[0] || {}));
        console.log("Dato completo:", JSON.stringify(this.datos[0]));
      } catch (e) {
        console.error("Error al cargar datos:", e);
        this.datos = [];
      } finally {
        this.cargando = false;
      }
    },

    async fetchCargas() {
      try {
        const { data } = await api.get(`/vwcargas/activas-por-tramite/${this.p_idtramite}`);
        this.cargas = Array.isArray(data) ? data : [];
      } catch (e) {
        console.error("Error al cargar cargas:", e);
      }
    },

    labelCarga(idCarga) {
      const carga = this.cargas.find(c => c.idCarga === idCarga);
      return carga ? `Período ${carga.secuencial}` : `Carga ${idCarga}`;
    },

    formatFecha(fecha) {
      if (!fecha) return '—';
      try {
        const d = fecha instanceof Date ? fecha : new Date(fecha);
        if (isNaN(d.getTime())) return '—';
        const dd  = String(d.getDate()).padStart(2, '0');
        const mm  = String(d.getMonth() + 1).padStart(2, '0');
        const yyyy = d.getFullYear();
        return `${dd}/${mm}/${yyyy}`;
      } catch {
        return '—';
      }
    },

    // ── Ordenamiento tabla ───────────────────────────────
    ordenarTabla(campo) {
      if (this.campoOrdenTabla === campo) {
        this.ascendenteTabla = !this.ascendenteTabla;
      } else {
        this.campoOrdenTabla = campo;
        this.ascendenteTabla = true;
      }
    },
    iconOrdenTabla(campo) {
      if (this.campoOrdenTabla !== campo) return "⇅";
      return this.ascendenteTabla ? "↑" : "↓";
    },

    // ── Exportar Excel ────────────────────────────────────
    exportToExcel() {
      if (!this.porCarga.length) return;
      const headers = [
        "Período", "Total",
        "F. Reg. Mín.", "F. Reg. Máx.",
        "F. Act. Obs. Mín.", "F. Act. Obs. Máx.",
        "F. Act. Resp. Mín.", "F. Act. Resp. Máx.",
      ];
      const data = this.porCargaOrdenada.map(item => [
        this.labelCarga(item.idCarga),
        item.total,
        this.formatFecha(item.minFechaReg),
        this.formatFecha(item.maxFechaReg),
        this.formatFecha(item.minFechaActObs),
        this.formatFecha(item.maxFechaActObs),
        this.formatFecha(item.minFechaActResp),
        this.formatFecha(item.maxFechaActResp),
      ]);
      // Fila total
      data.push([
        "Global", this.datos.length,
        this.resumenGlobal.minFechaReg,    this.resumenGlobal.maxFechaReg,
        this.resumenGlobal.minFechaActObs, this.resumenGlobal.maxFechaActObs,
        this.resumenGlobal.minFechaActResp,this.resumenGlobal.maxFechaActResp,
      ]);
      const ws = XLSX.utils.aoa_to_sheet([headers, ...data]);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Fechas por Período");
      XLSX.writeFile(wb, `fechas_periodo_${this.p_idtramite}.xlsx`);
    },
  },
};
</script>

<style scoped>
.nav-tabs .nav-link.active {
  background-color: #0d6efd;
  color: #fff !important;
  border-color: #0d6efd #0d6efd #fff;
}
.th-sort {
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
  font-size: 0.8rem;
}
.th-sort:hover {
  background-color: #3d5166;
}
</style>